import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpectrumLightingD65 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.865 10.058v-7.02h2.27v7.02zm11.781 4.896-1.58-1.58L38 8.33l1.62 1.65zm3.296 10.18v-2.268h7.02v2.269zM22.865 44.963v-7h2.27v7zm-9.503-30.058-5-4.904L10 8.4l4.973 4.954zM38.05 39.639l-4.985-5.012 1.55-1.53 5.016 4.872zM3.039 25.135v-2.27h7.019v2.27zm6.973 14.503L8.4 38l4.904-4.904.83.768.85.801zM24.005 35q-4.582 0-7.793-3.207T13 24.005t3.207-7.793T23.995 13q4.582 0 7.793 3.207T35 23.995q0 4.583-3.207 7.793Q28.586 35 24.005 35m-.008-2.27q3.638 0 6.186-2.544t2.548-6.183-2.545-6.186q-2.545-2.547-6.183-2.548t-6.186 2.545q-2.547 2.546-2.548 6.183t2.545 6.186q2.546 2.547 6.183 2.548" })
});
export default SvgSpectrumLightingD65;
